
export class RegistrationTransportOption {
  
  id: number;
  amountOfPallettes: number;
  amountOfBoxes: number;
  amountInKilogramm: number;
  amountInLiter: number;
  amountOthers: string;

  transportOptions = new Array<RegistrationTransportOption>();

  selectedParameterValues = new Array<number>();

  constructor(option: any) {

    this.id = option?.id;
    this.amountOfPallettes = option?.amountOfPallettes;
    this.amountOfBoxes = option?.amountOfBoxes;
    this.amountInKilogramm = option?.amountInKilogramm;
    this.amountInLiter = option?.amountInLiter;
    this.amountOthers = option?.amountOthers;

    if (option.transportOptions != null) {
      for (const to of option.transportOptions) {
        this.transportOptions.push(new RegistrationTransportOption(to));
      }
    }

    if (option.selectedParameterValues != null) {
      for (const value of option.selectedParameterValues) {
        this.selectedParameterValues.push(value.id);
      }
    }
  }
}